var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEarnPoints(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5006 12.2506C23.5007 10.6154 22.4415 9.16857 20.8826 8.67465C21.636 7.22345 21.3622 5.45145 20.206 4.29529C19.0498 3.13912 17.2778 2.86533 15.8266 3.61865C15.333 2.05955 13.886 1 12.2506 1C10.6152 1 9.16834 2.05955 8.67465 3.61865C7.22345 2.86533 5.45145 3.13912 4.29529 4.29529C3.13912 5.45145 2.86533 7.22345 3.61865 8.67465C2.05955 9.16834 1 10.6152 1 12.2506C1 13.886 2.05955 15.333 3.61865 15.8266C2.86533 17.2778 3.13912 19.0498 4.29529 20.206C5.45145 21.3622 7.22345 21.636 8.67465 20.8826C9.16834 22.4417 10.6152 23.5013 12.2506 23.5013C13.886 23.5013 15.333 22.4417 15.8266 20.8826C17.2778 21.636 19.0498 21.3622 20.206 20.206C21.3622 19.0498 21.636 17.2778 20.8826 15.8266C22.4413 15.3324 23.5004 13.8858 23.5006 12.2506Z",
    fill: "#F7ED90",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.68176 10.0909V14.4546V10.0909Z",
    fill: "#F7ED90"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.68176 10.0909V14.4546",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 12.2727H11.8636H7.5Z",
    fill: "#F7ED90"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12.2727H11.8636",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0454 9H15.1363V15.5455",
    fill: "#F7ED90"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0454 9H15.1363V15.5455",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarnPoints);
export default __webpack_public_path__ + "static/media/earn-points.a23962efb982f73eafaf91f26fa1a2d5.svg";
export { ForwardRef as ReactComponent };